<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="授课教师" name="teacher">
        <teacher-tab :visible="activeName === 'teacher'"></teacher-tab>
      </el-tab-pane>
      <el-tab-pane label="教师学员" name="teacherAndStudent">
        <teacher-and-student
          :visible="activeName === 'teacherAndStudent'"
        ></teacher-and-student>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import teacherTab from "./teacherTab/index.vue";
import teacherAndStudent from "./teacherAndStudent/index.vue";
import { PageModule } from "@/store/module/page";
export default {
  components: {
    teacherTab,
    teacherAndStudent,
  },
  data() {
    return {
      activeName: "teacher",
    };
  },
  created() {
    const tab = PageModule.pageInfo.teacherAndStudent;
    if (tab.tab_Info) {
      this.activeName = tab.tab_Info;
    }
  },
  methods: {
    handleClick(tab) {
      PageModule.SET_PAGE_INFO({
        name: "teacherAndStudent",
        key: "tab_Info",
        value: tab._props.name,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
